import { IPeriod } from "./model";
import { getAllPeriodLevels } from "./getAllPeriodLevels";

/**
 *
 * Find the last period which matches the selected period for the element
 *
 * @param itemid
 * @param periodName
 * @param itemPeriodlevelid
 * @returns
 */

export const matchElementPeriodToRequestedPeriod = async (
  itemid: string,
  periodName: string,
  itemPeriodlevelid: string
) => {
  return getAllPeriodLevels(itemid).then((periodlist) => {
    // find period which is requested
    let askedPeriod: IPeriod | undefined;
    periodlist.forEach((periodlevel) => {
      const found = periodlevel.periods.find(
        (period) => period.name === periodName
      );
      if (found) {
        askedPeriod = found;
      }
    });

    if (!askedPeriod) {
      return undefined;
    }

    // Asked period level, for example Year 2023
    // if the level whic is asked is the same then just use the period
    if (askedPeriod.periodlevel === itemPeriodlevelid || !itemPeriodlevelid) {
      return askedPeriod;
    }

    const elementPeriodLevel = periodlist.find(
      (level) => level.id === itemPeriodlevelid
    );

    const start = new Date(askedPeriod.startdate);
    const end = new Date(askedPeriod.enddate);

    const lastMatching =
      elementPeriodLevel?.periods.filter((period) => {
        return !(
          new Date(period.startdate) > end || new Date(period.enddate) < start
        );
      }) || [];

    return lastMatching.pop();
  });
};
